 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0370aa5c":"c513196f","chunk-08f4dcb5":"11c35263","chunk-0b5440e6":"c68f2f8d","chunk-0cf2afe6":"8791401d","chunk-13c51ba7":"dcb0acbc","chunk-16117f3f":"df38922a","chunk-181515e9":"0f47acb6","chunk-1a2f6c5a":"e077c3e0","chunk-602be7b6":"1dce2761","chunk-77802c51":"d482efe8","chunk-21b37d90":"4ecb16b2","chunk-2c384648":"26659b43","chunk-2d58ef8a":"3a946820","chunk-2e51e5a4":"5343df46","chunk-208d91aa":"0c310469","chunk-5fae075f":"3b96e438","chunk-382fe77c":"b6d41e09","chunk-38f9685a":"d73c8e4b","chunk-3f047b50":"2f87ef9e","chunk-40d4b2ba":"45a66e26","chunk-4353c48c":"bfd4dab5","chunk-4a193f8b":"d37ee0d4","chunk-4c63fae4":"7d2b992b","chunk-5a7ed9fa":"bb2996ad","chunk-6281237a":"6b86086f","chunk-640c2142":"d195b304","chunk-653ae9a4":"f2c996bf","chunk-6c5ef39f":"77d39b7c","chunk-71cb649d":"e41fa3d1","chunk-733b0090":"35536caa","chunk-76b5d73a":"b0785b7d","chunk-c1ac581c":"29fb8713","chunk-ca512f1a":"034ed517","chunk-d14aeb32":"4dacf663","chunk-d66a7cca":"4076c0b1","chunk-e47ebb04":"fce7e58a","chunk-ef75dc0a":"1557ed8f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0370aa5c":1,"chunk-08f4dcb5":1,"chunk-0b5440e6":1,"chunk-0cf2afe6":1,"chunk-13c51ba7":1,"chunk-16117f3f":1,"chunk-181515e9":1,"chunk-1a2f6c5a":1,"chunk-602be7b6":1,"chunk-77802c51":1,"chunk-21b37d90":1,"chunk-2c384648":1,"chunk-2d58ef8a":1,"chunk-208d91aa":1,"chunk-5fae075f":1,"chunk-382fe77c":1,"chunk-38f9685a":1,"chunk-3f047b50":1,"chunk-40d4b2ba":1,"chunk-4353c48c":1,"chunk-4a193f8b":1,"chunk-4c63fae4":1,"chunk-5a7ed9fa":1,"chunk-6281237a":1,"chunk-640c2142":1,"chunk-653ae9a4":1,"chunk-6c5ef39f":1,"chunk-71cb649d":1,"chunk-733b0090":1,"chunk-76b5d73a":1,"chunk-c1ac581c":1,"chunk-ca512f1a":1,"chunk-d14aeb32":1,"chunk-d66a7cca":1,"chunk-e47ebb04":1,"chunk-ef75dc0a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0370aa5c":"34aa5512","chunk-08f4dcb5":"09140bc5","chunk-0b5440e6":"30c4b3a8","chunk-0cf2afe6":"f7f2a8b1","chunk-13c51ba7":"324062cc","chunk-16117f3f":"7d3564aa","chunk-181515e9":"0c93ff1d","chunk-1a2f6c5a":"76bb9d56","chunk-602be7b6":"123116fb","chunk-77802c51":"d31831a9","chunk-21b37d90":"3b7b7410","chunk-2c384648":"c2e10f01","chunk-2d58ef8a":"9d3e79a9","chunk-2e51e5a4":"31d6cfe0","chunk-208d91aa":"824476de","chunk-5fae075f":"b25a8451","chunk-382fe77c":"829b9609","chunk-38f9685a":"6bf300cf","chunk-3f047b50":"bce10cd2","chunk-40d4b2ba":"ccc9201a","chunk-4353c48c":"2fb16de5","chunk-4a193f8b":"731e6ed3","chunk-4c63fae4":"b1334ea0","chunk-5a7ed9fa":"572f8308","chunk-6281237a":"00fcbcae","chunk-640c2142":"461ae7de","chunk-653ae9a4":"6eb3282f","chunk-6c5ef39f":"ea4d3bf7","chunk-71cb649d":"2efdcaec","chunk-733b0090":"f5680653","chunk-76b5d73a":"83ca749b","chunk-c1ac581c":"1a63324b","chunk-ca512f1a":"43697eeb","chunk-d14aeb32":"70e30b8f","chunk-d66a7cca":"64d28db6","chunk-e47ebb04":"c46f9fea","chunk-ef75dc0a":"6ae13aae"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/college_new/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
